export default "__VITE_ASSET__1230c449__"